//Login Data
const LOGIN_DETAILS = 'LOGIN_DETAILS';

const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';

const VERIFY_REQUEST = 'VERIFY_REQUEST';
const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
const VERIFY_FAILURE = 'VERIFY_FAILURE';

const FORGOTPASSWORD_REQUEST = 'FORGOTPASSWORD_REQUEST';
const FORGOTPASSWORD_SUCCESS = 'FORGOTPASSWORD_SUCCESS';
const FORGOTPASSWORD_FAILURE = 'FORGOTPASSWORD_FAILURE';

const CHANGEPASSWORD_REQUEST = 'CHANGEPASSWORD_REQUEST';
const CHNAGEPASSWORD_SUCCESS = 'CHANGEPASSWORD_SUCCESS';
const CHANGEPASSWORD_FAILURE = 'CHANGEPASSWORD_FAILURE';

const SENDOTP_REQUEST = 'SENDOTP_REQUEST';
const SENDOTP_SUCCESS = 'SENDOTP_SUCCESS';
const SENDOTP_FAILURE = 'SENDOTP_FAILURE';



export {
    LOGIN_DETAILS, LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE,VERIFY_REQUEST,VERIFY_SUCCESS,VERIFY_FAILURE,FORGOTPASSWORD_REQUEST,
    FORGOTPASSWORD_SUCCESS,FORGOTPASSWORD_FAILURE,CHANGEPASSWORD_REQUEST,CHNAGEPASSWORD_SUCCESS,CHANGEPASSWORD_FAILURE,SENDOTP_REQUEST,
    SENDOTP_SUCCESS,SENDOTP_FAILURE
};